import React, { useEffect, useState } from "react";
import PopoverDisplay from "../NavQuickLinks/PopoverDisplay";
import PopoverVerticalMenu from "./PopoverVerticalMenu";
import { ExternalLink, InternalLink } from "../NavQuickLinks/Item";

const Item = ({
  type,
  pathname,
  popoverMenu,
  setOpenItem = () => {},
  openItem,
  title,
  ...other
}): React.ReactNode => {
  const [ref, setRef] = useState(null);

  const onMouseEnter = (e): void => {
    if (title !== openItem && popoverMenu !== null) {
      setOpenItem(title);

      setRef(e?.currentTarget);
    }
  };

  const onMouseLeave = (e): void => {
    setRef(null);

    setOpenItem(null);
  };
  const display = () => {
    if (type === "Internal") {
      return (
        <InternalLink
          activeLink={pathname}
          shouldDisplay={openItem === title}
          {...other}
          title={title}
        />
      );
    }
    return <ExternalLink {...other} title={title} />;
  };

  useEffect(() => {
    if (openItem !== title) {
      setRef(null);
    }
  }, [title, openItem]);

  return (
    <div className="flex-direction-column center centered-text">
      <div className="item hoverable-component center centered-text">
        <span
          onMouseEnter={onMouseEnter}
          onClick={onMouseEnter}
          aria-owns="mouse-over-popover center"
          aria-haspopup="true"
          className="center centered-text"
        >
          <div
            ref={ref}
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "center",
              alignContent: "center",
              justifyContent: "center",
            }}
          >
            <div>{display()}</div>{" "}
            <div
              className="arrow-up"
              style={{
                visibility: title === openItem ? "visible" : "hidden",
                position: "absolute",
                top: 44,
              }}
            />
          </div>
        </span>
      </div>

      {popoverMenu && (
        <PopoverDisplay
          popoverEnter={onMouseEnter}
          popoverLeave={onMouseLeave}
          closePopover={onMouseLeave}
          anchorRef={ref}
          marginTop={20}
          popoverOpen={ref !== null && title === openItem}
        >
          <PopoverVerticalMenu menu={popoverMenu} />
        </PopoverDisplay>
      )}
    </div>
  );
};

export default Item;
